import ResendOrderModule from './ResendOrder.module';

export * from './ResendOrderModuleProps';
export default ResendOrderModule;
